import axios from "axios";
import { TokenService } from "./token.service";
import store from "@/store";
import AuthService from "../services/auth.service";
var querystring = require("querystring");

const ApiService = {
  _401interceptor: null,
  token: null,
  download_timeout: null,
  default_timeout: 1000 * 2000, //2000 secs

  mount401Interceptor() {
    this._401interceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        /*if (error.request.status == 401) {
                    /*if (error.config.url.includes('/o/token/')) {
                      // Refresh token has failed. Logout the user
                      console.log("API SERVICE: dispatch logout: ", error)
                      store.dispatch('auth/logout')
                      throw error
                    } else {
                      // Refresh the access token
                      console.log("API SERVICE: dispatch refresh: ", error)
                      try {
                        await store.dispatch('auth/refreshToken')
                        // Retry the original request
                        return this.customRequest({
                          method: error.config.method,
                          url: error.config.url,
                          data: error.config.data
                        })
                      } catch (e) {
                        // Refresh has failed - reject the original request
                        throw error
                      }*
                    // Refresh token has failed. Logout the user
                    console.log("API SERVICE: dispatch logout: ", error)
                    store.dispatch('auth/logout')
                } else*/
        throw error;
      }
    );
  },

  unmount401Interceptor() {
    // Eject the interceptor
    axios.interceptors.response.eject(this._401interceptor);
  },

  init(settings) {
    axios.defaults.baseURL = settings.APIURL;
    this.download_timeout = settings.download_timeout
      ? settings.download_timeout
      : this.default_timeout;
    // axios.defaults.timeout = 1000 * 60 * 2; //2 minutes
    this.mount401Interceptor();
    //this.setAuthHeader()
  },

  setAuthHeader() {
    //for panacea sso
    //axios.defaults.headers.common["x-access-token"] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjIsImV4cCI6MTU2NDk5MTk2ODkwOSwiaXNzIjoxMn0.TLcKN0W80eQCpC71Kp2ERqj3PZ_pBCZywmfHxG7RSpw'

    //for auth module
    let token = TokenService.getToken();
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    if (store.getters["common/language"]) {
      axios.defaults.headers.common["Accept-Language"] =
        store.getters["common/language"].language;
    }
    // console.log("auth");
  },

  setGuestHeader() {
    axios.defaults.headers.common = {};
    axios.defaults.headers.common["Guest"] = "ShareFiles";
    if (store.getters["common/language"]) {
      axios.defaults.headers.common["Accept-Language"] =
        store.getters["common/language"].language;
    }
  },

  setLockHeader() {
    axios.defaults.headers.common = {};
    axios.defaults.headers.common["Lock-State"] = `lock`;
  },
  setUnlockHeader(lockId) {
    axios.defaults.headers.common = {};
    axios.defaults.headers.common["Lock-State"] = `unlock`;
    axios.defaults.headers.common["Lock-Id"] = lockId;
  },

  removeHeaders() {
    axios.defaults.headers.common = {};
    let token = TokenService.getToken();
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  },

  get(resource, timeout) {
    this.setAuthHeader();
    return axios.get(resource, { timeout: timeout?timeout:this.download_timeout });
  },

  getRedmine(resource, key) {
    const headers = { "Accept": "application/json", "X-Redmine-API-Key": key };
    return axios.get(resource, { headers });
  },

  getGuest(resource) {
    this.setGuestHeader();
    return axios.get(resource, {timeout: 1000 * 60 * 10});
  },

  post(resource, data) {
    this.setAuthHeader();
    return axios.post(resource, data, {timeout: 1000 * 60 * 10});
  },

  postRedmine(resource, key, data) {
    const headers = { "Accept": "application/json", "X-Redmine-API-Key": key, "Content-Type": "application/xml" };
    return axios.post(resource, data, { headers });
  },

  postGuest(resource, data) {
    this.setGuestHeader();
    return axios.post(resource, data, {timeout: 1000 * 60 * 10});
  },

  postFile(resource, data) {
    this.setAuthHeader();
    return axios.post(resource, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 1000 * 60 * 10
    });
  },

  put(resource, data) {
    this.setAuthHeader();
    return axios.put(resource, data, {timeout: 1000 * 60 * 10});
  },

  putRedmine(resource, key, data) {
    const headers = { "Accept": "application/json", "X-Redmine-API-Key": key, "Content-Type": "application/xml" };
    return axios.put(resource, data, { headers });
  },

  delete(resource, data) {
    this.setAuthHeader();
    return axios.delete(resource, { data }, {timeout: 1000 * 60 * 10});
  },

  deleteRedmine(resource, key) {
    const headers = { "Accept": "application/json", "X-Redmine-API-Key": key };
    return axios.delete(resource, { headers });
  },

  postFileRedmine(resource, key, data, cType) {
    const headers = { "Accept": "application/json", "X-Redmine-API-Key": key, "Content-Type": cType };
    return axios.post(resource, data, {
      headers: headers
    });
  },

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    this.setAuthHeader();
    return axios(data);
  },

  download(url) {
    console.log("download: ", url, this.download_timeout);
    this.setAuthHeader();
    return axios({
      url: url,
      method: "GET",
      responseType: "blob", // important
      timeout: this.download_timeout,
    });
  },

  async downloadPost(url, filename, payload) {
    console.log("post download", url, this.download_timeout);
    this.setAuthHeader();
    // const CancelToken = axios.CancelToken;
    // const source = CancelToken.source();
    // try {
    //   let response = null;
    //   setTimeout(() => {
    //     if (response === null) {
    //       source.cancel();
    //     }
    //   }, this.download_timeout);

    //   response = await axios({
    //     url: url,
    //     method: "POST",
    //     responseType: "blob", // important
    //     data: payload,
    //     cancelToken: source.token,
    //   });
    //   // await axios.post("/url", null, { cancelToken: source.token });
    //   return new Promise((resolve, reject) => {
    //     resolve(response);
    //   });
    // } catch (error) {
    //   // throw error;
    //   return new Promise((resolve, reject) => {
    //     reject(error);
    //   });
    // }
    return axios({
      url: url,
      method: "POST",
      responseType: "blob", // important
      data: payload,
      timeout: this.download_timeout
    });
  },
  postConfirmMatch(resource, data, sourceOfInformation) {
    this.setAuthHeader();
    return axios.post(resource, data, {
      headers: {
        "source-of-information": sourceOfInformation,
      },
    });
  },
  getCanadaPost(resource) {
    axios.defaults.headers.common = {};
    return axios.get(resource, {
      withCredentials: false,
    });
  },

  // postPaymentsForm(resource, authData, data) {
  //   axios.defaults.headers.common = {};
  //   return axios.post(resource, querystring.stringify(data), {
  //     withCredentials: false,
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded",
  //       Authorization:
  //         "Basic " + btoa(`${authData.Username}:${authData.Password}`),
  //     },
  //   });
  // },

  // getPayments(resource, token) {
  //   axios.defaults.headers.common = {};
  //   return axios.get(resource, {
  //     withCredentials: false,
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       Accept: "application/vnd.fif.api.v1+json",
  //     },
  //   });
  // },
};

export default ApiService;
